export interface ModalFormOptions {
    confirmBtnTitle?: string;
    [key: string]: unknown;
}

export default class ModalFormPayload {
    title: string | null = null;
    componentCreator: (() => React.ReactNode) | null = null;
    onSave: (() => void) | null = null;
    onValidate: (() => boolean) | null = null;
    isReadOnly: boolean = false;
    onDelete: (() => void) | null = null;
    onCancel: (() => void) | null = null;
    options: ModalFormOptions | null = null;
}
